import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const UploadDragRoot = styled(Col)(
    ({ theme }) => css`
        position: absolute;
        background-color: ${theme.palette.gray[100]};
        width: 100%;
        height: 100%;
        z-index: 3;
    `,
);
